var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconRocket = function SvgIconRocket(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 45,
    viewBox: "0 0 46 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.80053 25.5547C9.08001 24.8877 12.0898 17.8088 16.4771 12.8808L13.6371 12.3008C12.2171 12.0215 10.7543 12.4738 9.74348 13.4852L3.26979 19.9628C2.19443 21.0388 2.5392 22.8674 3.93778 23.4694L8.80053 25.5547Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.065 37.564C13.2715 36.8402 13.2961 36.0765 13.1366 35.3409C12.773 33.5634 11.2868 32.1238 9.49861 31.817C8.75826 31.681 7.99579 31.7298 7.27887 31.9593C6.56196 32.1887 5.91278 32.5917 5.38898 33.1323C4.2191 34.3245 3.42376 37.98 3.00423 40.3492C2.82287 41.4038 3.7672 42.3185 4.81547 42.1037C7.1701 41.6089 10.7982 40.6823 11.9528 39.4903C12.4765 38.9496 12.8585 38.2879 13.065 37.564Z",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3681 2.87137C34.5717 2.29273 26.183 2.62664 16.2287 12.9032C12.6788 16.5679 9.98994 22.1229 8.84693 24.6362L8.84677 24.6365C8.27787 25.8887 8.60071 27.3338 9.5447 28.2482L16.5379 35.0221C17.5093 35.9631 18.9419 36.2089 20.1668 35.6062C22.655 34.3991 28.1146 31.5153 31.6622 27.8529C41.6166 17.5764 41.6833 9.1814 40.984 5.40528L40.9841 5.40527L40.9818 5.39375C40.8569 4.75837 40.5407 4.17638 40.0756 3.72585C39.6105 3.27532 39.0187 2.9778 38.3797 2.87321L38.3797 2.87314L38.3681 2.87137Z",
    fill: "#7A7A7A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0684 13.1033C23.229 13.1486 20.9428 15.5087 20.988 18.3482C21.0332 21.1877 23.3934 23.4739 26.2328 23.4287C29.0723 23.3834 31.3585 21.0232 31.3133 18.1838C31.2681 15.3443 28.9079 13.0581 26.0684 13.1033Z",
    fill: "#525252",
    stroke: "#7A7A7A",
    strokeWidth: 1.78051
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9859 35.9226C19.6436 35.6218 26.6218 32.3854 31.4059 27.8416L32.0771 30.6614C32.402 32.0717 31.9971 33.5483 31.0188 34.5912L24.7531 41.2703C23.7123 42.3798 21.8736 42.0941 21.2269 40.7156L18.9859 35.9226Z",
    fill: "#525252"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6888 22.2507L28.0747 14.043C28.5631 14.3574 29.7347 15.08 30.5141 15.4543C31.4883 15.9221 31.0512 18.8294 31.0666 19.7959C31.0789 20.5691 29.4865 21.7546 28.6888 22.2507Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0684 13.1033C23.229 13.1486 20.9428 15.5087 20.988 18.3482C21.0332 21.1877 23.3934 23.4739 26.2328 23.4287C29.0723 23.3834 31.3585 21.0232 31.3133 18.1838C31.2681 15.3443 28.9079 13.0581 26.0684 13.1033Z",
    stroke: "white",
    strokeWidth: 1.78051
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3876_22214",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 8,
    y: 2,
    width: 34,
    height: 34
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.368 2.87086C34.5715 2.29222 26.1829 2.62613 16.2285 12.9027C12.6787 16.5674 9.9898 22.1224 8.8468 24.6357L8.84664 24.636C8.27773 25.8882 8.60058 27.3333 9.54457 28.2476L16.5377 35.0216C17.5092 35.9626 18.9417 36.2084 20.1667 35.6057C22.6549 34.3986 28.1145 31.5148 31.6621 27.8524C41.6165 17.5759 41.6831 9.18088 40.9839 5.40477L40.984 5.40476L40.9817 5.39324C40.8568 4.75785 40.5406 4.17586 40.0755 3.72534C39.6104 3.27481 39.0186 2.97729 38.3796 2.87269L38.3796 2.87263L38.368 2.87086Z",
    fill: "#87CBC8"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3876_22214)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 39.0132,
    cy: 3.16025,
    rx: 13.05,
    ry: 8.1,
    transform: "rotate(45.453 39.0132 3.16025)",
    fill: "#525252"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconRocket);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/icon-rocket.f0dbb2ff0ed08b5401e088cc21321963.blank.svg";